import React from 'react';
import {Form, Select} from "antd";
import {useSelector} from "react-redux";
import {useGetVehicleQuery} from "../slices/rootApiSlices/vehicleApiSlice";

const SearchVehicle = ({onChange}) => {

    const {user} = useSelector((state) => state.auth);
    const {data, error, isLoading} = useGetVehicleQuery(user?.token);

    const onSearch = (value) => {
        console.log('search:', value);
    };

    if (isLoading) {
        return (
            <div>yükleniyor</div>
        )
    }

    if (error) {
        return (
            <div>hata lütfen bekleyiniz</div>
        )
    }

    return (
        <Form.Item
            name="vehicle_id"
            rules={[{
                required: false,
                message: 'lütfen araç seçiniz !'
            }]}
            style={{width: '100%'}}
        >
            <Select
                disabled={true}
                showSearch
                placeholder="Araç seçiniz"
                optionFilterProp="children"
                onChange={onChange}
                loading={isLoading}
                onSearch={onSearch}
                filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                options={data !== null ? data?.data?.map((item) => {
                    return {
                        value: item.device_id,
                        label: item.plateNumber,
                        data: item.id,
                        device_id: item.device_id,
                    }
                }) : null}
            />
        </Form.Item>
    );
};

export default SearchVehicle;
